import SimpleProduct from '../simpleComponents/simpleProduct';
import React from 'react';
import VariationProduct from '../simpleComponents/VariationProduct';

export default function ProductsComponent({component, priority = false}) {

  const {title, description, simpleProducts, variationProducts} = component;

  let productItems = [];

  simpleProducts.map(simpleProduct => {
    const {simpleProduct: {id: simpleProductId}} = simpleProduct;
    productItems.push(<SimpleProduct
        priority={priority}
        item={simpleProduct}
        key={`SP_${simpleProductId}`}/>);
  });

  variationProducts.forEach(variationProduct => {
    const {id: variationProductId} = variationProduct.variationProduct;
    productItems.push(<VariationProduct
        item={variationProduct}
        key={`VARIATION_${variationProductId}`}/>);
  });

  return <section>
    <center>
      <h2 className={'uppercase font-title tracking-wide text-3xl mt-8 p-8'}>
        {title}
      </h2>
      <p className={'text-gray-600 w-4/5 md:w-3/4 xl:w-1/2 py-6 px-6 md:px-10 lg:px-20'}>
        {description}
      </p>
    </center>

    <div
        className="container p-8 mx-auto bg-white mb-8 shadow shadow-lg rounded">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-20">
        {productItems}
      </div>
    </div>

  </section>;
}